export function validateOpen(open: boolean): boolean {
	if (typeof open !== 'boolean') {
		console.error('Invalid data open');
		return false;
	}
	return true;
}
